const withAreas = areas => prevProjectOrTemplate => ({
    ...prevProjectOrTemplate,
    areas,
});

export default withAreas;
